import { Component, inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import { DType, DTypeStatus } from '@grupo-constant/next-dtype/types';
import { Subject } from 'rxjs';
import { DtypeComponentListComponent } from '../dtype-component-list/dtype-component-list.component';
import { DTypeService } from '../dtype.service';

@Component({
    selector: 'dtype-editor-preview',
    templateUrl: 'dtype-editor-preview.component.html',
    styleUrls: ['./dtype-editor-preview.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DtypeComponentListComponent]
})
export class DtypeEditorPreviewComponent implements OnInit, OnDestroy {

    @Input() dtype: DType;
    @Input() status: DTypeStatus;

    dtypeForm: DTypeForm;
    object: any = {};

    ionicMode: 'md' | 'ios' = 'md';
    themeMode: 'auto' | 'light' | 'dark';

    private unsubscribeAll = new Subject<void>();
    private dtypeService = inject(DTypeService);

    async ngOnInit() {
        this.dtypeForm = this.dtypeService.getDtypeFormFromDtype(this.dtype, { isUpdate: true });
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }
}
